import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { SabisNgxDialogService } from "sabis-components2";
import { CookiesDetailsComponent } from './cookies-details/cookies-details.component';

@Injectable({
  providedIn: 'root'
})
export class AppCookiesService {

  constructor(private _dialogService: SabisNgxDialogService) {

  }

  public readMore(): Observable<boolean>{
    var dialog = this._dialogService.open(CookiesDetailsComponent, {
      panelClass: 'sc-full-height'
    });

    return dialog.afterClosed();
  }
}
